import { Avatar, Tooltip } from '@material-ui/core';
import {
  IconBrandWhatsapp,
  IconMapPin,
  IconMapPins,
  IconPhoneCall,
  IconStar,
  IconUser,
} from '@tabler/icons';

import {
  Button,
  Modal,
  ModalBody,
  ModalDescription,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from '#root/components/ui';
import styles from './styles.module.scss';

const ShopperDeliverySetupDialog = (props) => {
  const { open = false, onClose, deal } = props;
  const traveler = deal?.offer?.traveler;

  return (
    <Modal open={open} onClose={onClose}>
      <ModalHeader icon={<IconMapPins />}>
        <ModalTitle>Indicaciones para la entrega</ModalTitle>
        <ModalDescription>
          El viajero ha compartido contigo datos e indicaciones para que lo contactes.
        </ModalDescription>
      </ModalHeader>
      <ModalBody className={styles.root}>
        <p className={styles.note}>
          Puede que recién haya llegado de viaje, por favor contáctalo con respeto y paciencia.
        </p>
        <div className={styles.dealDetails}>
          <div className={styles.user}>
            <Avatar className={styles.avatar} src={traveler?.picture_path}>
              {traveler?.one_firstname?.charAt(0)}
            </Avatar>
            <div className={styles.userInfo}>
              <h6 className={styles.name}>{traveler?.mask_fullname}</h6>
              {traveler?.calvia && (
                <Tooltip arrow title="Puntaje del viajero" placement="top">
                  <div className={styles.userScore}>
                    <IconStar />
                    <span>{traveler?.calvia}</span>
                  </div>
                </Tooltip>
              )}
            </div>
          </div>
          <div className={styles.deliveryDate}>
            <span>Fecha pactada</span>
            <span className={styles.text}>{deal?.fixed_delivery_date}</span>
          </div>
        </div>
        <div className={styles.deliverySetup}>
          {deal.delivery_setup.custom_message && <p>{deal.delivery_setup.custom_message}</p>}
          <div className={styles.body}>
            <div className={styles.col}>
              {deal.delivery_setup.pickup_contact && (
                <p>
                  <IconUser size={14} /> {deal.delivery_setup.pickup_contact}
                </p>
              )}
              {deal.delivery_setup.phone_number && (
                <p>
                  <IconPhoneCall size={14} /> {deal.delivery_setup.phone_number}
                </p>
              )}
              {deal.delivery_setup.whatsapp_number && (
                <p>
                  <IconBrandWhatsapp size={14} /> {deal.delivery_setup.whatsapp_number}
                </p>
              )}
            </div>
            <div className={styles.col}>
              {deal.delivery_setup.pickup_address && (
                <p>
                  <IconMapPin size={14} /> {deal.delivery_setup.pickup_address}
                </p>
              )}
            </div>
          </div>
          {deal.delivery_setup.pickup_details && (
            <p className={styles.details}>{deal.delivery_setup.pickup_details}</p>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button variant="outline" onClick={onClose}>
          Cerrar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ShopperDeliverySetupDialog;
